import script from "./MessageComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageComposer.vue?vue&type=script&setup=true&lang=ts"

import "./MessageComposer.vue?vue&type=style&index=0&id=33de5283&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33de5283"]])

export default __exports__